import React, { Component } from 'react';
import $ from "jquery";
import { jsonHeaders } from '../components/NavMenu';
import './css/Register.css';


export class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            displayName: ""
        };
    }

    createUser(e) {
        e.preventDefault();
        const { firstName, lastName, displayName } = this.state;
        const params = new URLSearchParams(window.location.search);
        const username = params.get('username');

        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
                "username": username,
                "firstName": firstName,
                "lastName": lastName,
                "displayName": displayName
            }),
            redirect: 'follow'
        };

        fetch(`/api/accounts/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
            })
        window.location.href = '/account';
    }

    render() {
        const { } = this.state;
        return (
            <div className='register-page'>
                <h2>Please fill in your information.</h2>
                <form onSubmit={(e) => { this.createUser(e) }}>
                    First Name: <input />
                    Last Name: <input />
                    Display Name: <input required onChange={(e) => { this.setState({ displayName: e.target.value }) }} />
                    <button className='btn btn-primary'>Save</button>
                </form>
            </div>
        );
    }
}